import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = { class: "text-2xl font-bold text-white mb-6" }
const _hoisted_3 = {
  key: 0,
  class: "bg-gray-800 rounded-lg p-8 text-center text-gray-400 mb-6"
}
const _hoisted_4 = { class: "flex flex-col items-center" }
const _hoisted_5 = {
  key: 2,
  class: "min-h-[600px] flex flex-col"
}
const _hoisted_6 = {
  key: 0,
  class: "flex justify-center items-center py-20 flex-grow"
}
const _hoisted_7 = {
  key: 1,
  class: "space-y-4 flex-grow"
}
const _hoisted_8 = { class: "flex flex-col md:flex-row md:items-start" }
const _hoisted_9 = { class: "flex-shrink-0 mb-4 md:mb-0 md:mr-4" }
const _hoisted_10 = { class: "bg-gray-700 rounded-full w-12 h-12 flex items-center justify-center text-lg font-bold text-blue-400" }
const _hoisted_11 = { class: "flex-grow" }
const _hoisted_12 = { class: "flex flex-col md:flex-row md:items-center md:justify-between gap-2 mb-3" }
const _hoisted_13 = { class: "text-lg font-medium text-white" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = { class: "text-gray-300" }
const _hoisted_16 = {
  key: 0,
  class: "mt-3 p-3 bg-gray-700 rounded-md"
}
const _hoisted_17 = { class: "text-gray-300" }
const _hoisted_18 = { class: "flex flex-col md:flex-row md:justify-between md:items-center gap-2 mt-3 text-sm text-gray-500" }
const _hoisted_19 = {
  key: 2,
  class: "bg-gray-800 rounded-lg p-8 text-center text-gray-400 mt-6 flex-grow flex items-center justify-center"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 3,
  class: "mt-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ProfileRatingStats = _resolveComponent("ProfileRatingStats")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, " Ocene korisnika " + _toDisplayString(_ctx.username), 1),
    (_ctx.authRequired)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("svg", {
              class: "h-16 w-16 text-gray-500 mb-4",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              })
            ], -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-lg mb-4" }, " Morate biti ulogovani da biste videli ocene korisnika. ", -1)),
            _createVNode(_component_router_link, {
              to: "/login",
              class: "bg-blue-600 hover:bg-blue-500 text-white px-6 py-2 rounded-lg transition-colors"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" Prijavite se ")
              ])),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.authRequired)
      ? (_openBlock(), _createBlock(_component_ProfileRatingStats, {
          key: 1,
          stats: _ctx.stats,
          userRole: _ctx.userRole,
          activeFilter: _ctx.ratingFilter,
          onChangeRole: _cache[0] || (_cache[0] = (role) => _ctx.$emit('change-role', role)),
          onChangeFilter: _cache[1] || (_cache[1] = (filter) => _ctx.$emit('change-filter', filter))
        }, null, 8, ["stats", "userRole", "activeFilter"]))
      : _createCommentVNode("", true),
    (!_ctx.authRequired)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.showLoader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500" }, null, -1)
              ])))
            : (!_ctx.loading && _ctx.ratings.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratings, (rating) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: rating.id,
                      class: "bg-gray-800 rounded-lg p-6 shadow-md"
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(rating.fromUser.username.charAt(0).toUpperCase()), 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("h3", _hoisted_13, _toDisplayString(rating.fromUser.username), 1),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["px-3 py-1 rounded-full text-sm font-medium", {
                      'bg-green-900 text-green-300': rating.isLike,
                      'bg-red-900 text-red-300': !rating.isLike,
                    }])
                              }, _toDisplayString(rating.isLike ? 'Pozitivna' : 'Negativna'), 3)
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_15, _toDisplayString(rating.comment), 1),
                          (rating.reply)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-gray-400 text-sm mb-1" }, "Odgovor:", -1)),
                                _createElementVNode("p", _hoisted_17, _toDisplayString(rating.reply), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(rating.createdAt)), 1),
                            _createVNode(_component_router_link, {
                              to: {
                    name: 'product-detail',
                    params: { id: rating.product.slug },
                  },
                              class: "text-blue-400 hover:underline flex items-center"
                            }, {
                              default: _withCtx(() => [
                                _cache[7] || (_cache[7] = _createElementVNode("svg", {
                                  class: "h-4 w-4 mr-1",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                  })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(rating.product.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", null, [
                      (_ctx.ratingFilter !== 'all')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_20, " Korisnik nema " + _toDisplayString(_ctx.ratingFilter === 'positive' ? 'pozitivnih' : 'negativnih') + " ocena kao " + _toDisplayString(_ctx.userRole === 'seller' ? 'prodavac' : 'kupac') + ". ", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_21, " Korisnik nema ocena kao " + _toDisplayString(_ctx.userRole === 'seller' ? 'prodavac' : 'kupac') + ". ", 1))
                    ])
                  ]))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.authRequired)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createVNode(_component_PaginationComponent, {
            meta: _ctx.meta,
            "current-page": _ctx.currentPage,
            onPageChange: _ctx.handlePageChange
          }, null, 8, ["meta", "current-page", "onPageChange"])
        ]))
      : _createCommentVNode("", true)
  ]))
}